/***
 * 小程序所有接口
 * @fjf
 */
import config from './config.js';

const interfaces = {
  login: {
    login: `${config.apiUrl}/auth/login`,//登录
    jtLogin: `${config.apiUrl}/auth/jtLogin`,//登录
    isFirstLogin: `${config.apiUrl}/monitor/logininfor/isFirstLogin`,//首次登录
    checkIdNum: `${config.apiUrl}/xcx/api/checkIdNum`,//鉴权类型和身份号
    getCompanyList: `${config.apiUrl}/xcx/api/getCompanyList`,//单位列表
    getArea: `${config.apiUrl}/xcx/api/companyFramework`,//行政规划
    getWxConfig: `${config.apiUrl}/xcx/api/getWxConfig`,//获取微信配置
  },
  oss: {
    listOss: `${config.apiUrl}/resource/oss/list`,//查询OSS对象存储列表
    listByIds: `${config.apiUrl}/resource/oss/listByIds`,//查询OSS对象基于id串
    oss: `${config.apiUrl}/xcx/api/oss`,//删除OSS对象存储
    upload: `${config.apiUrl}/resource/oss/upload`,//上传
  },
  user: {
    getThirdVideo: `${config.apiUrl}/xcx/api/pay`,//获取视频地址
    videoKeepalive: `${config.apiUrl}/xcx/api/keepalive`,//视频心跳
    videoStop: `${config.apiUrl}/xcx/api/stop`,//视频心跳停止
    videoController: `${config.apiUrl}/things/device/controller`,//视频控制
    getMesRecordPage: `${config.apiUrl}/xcx/api/getMesRecordPage`,//查询消息推送记录列表
    isRead: `${config.apiUrl}/xcx/api/isRead`,//标记消息已读
    getMesRecordCount: `${config.apiUrl}/xcx/api/getMesRecordCount`,//未读消息数量
    xcxPersonDetail: `${config.apiUrl}/village/communityPersonnel/xcxPersonDetail`,//获取用户详细信息
    xcxEditPerson: `${config.apiUrl}/village/communityPersonnel/xcxEditPerson`,//修改用户信息
    updatePwd: `${config.apiUrl}/system/user/profile/updatePwd`,//用户密码重置
    studentUpdatePwd: `${config.apiUrl}/baseData/patriarchInfo/updatePwd`,//用户密码重置
    getSetUser: `${config.apiUrl}/village/communityPersonnel/userDetail`,//查询账号详情
    addSetUser: `${config.apiUrl}/village/communityPersonnel/setUser`,//新增账号
    listCarouselImage: `${config.apiUrl}/xcx/api/getCarouselImageList`,//查询惠民轮播图列表
    listNotice: `${config.apiUrl}/xcx/api/getNoticeList`,//查询公告列表
    getNotice: `${config.apiUrl}/xcx/api/getNoticeInfo`,//查询公告详情
    listInfoType: `${config.apiUrl}/xcx/api/getInfoTypeList`,//查询资讯类型
    listInfoManage: `${config.apiUrl}/xcx/api/getInfoManageList`,//查询资讯管理列表
    getInfoManage: `${config.apiUrl}/xcx/api/getInfoManage`,//查询资讯管理详情
    listPlaceType: `${config.apiUrl}/xcx/api/getPlaceTypeList`,//查询场所类型列表
    listPlaceTypeAll: `${config.apiUrl}/village/placeType/list`,//查询场所类型列表
    listPlace: `${config.apiUrl}/xcx/api/getPlaceList`,//查询场所列表
    getPlace: `${config.apiUrl}/xcx/api/getPlace`,//查询场所详情
    listScenicManage: `${config.apiUrl}/xcx/api/getScenicManageList`,//查询景区管理列表
    getScenicManage: `${config.apiUrl}/xcx/api/getScenicManageInfo`,//查询景区管理详情
    listScenicSpot: `${config.apiUrl}/xcx/api/getScenicSpotList`,//查询景点管理列表
    getScenicSpot: `${config.apiUrl}/xcx/api/getScenicSpotInfo`,//查询景点管理详情
    getVillageIntroduction: `${config.apiUrl}/xcx/api/getInfoByCompanyId`,//查询乡村简介详情
    listOddjobManage: `${config.apiUrl}/xcx/api/getOddjobList`,//查询零工管理列表
    getOddjobManage: `${config.apiUrl}/xcx/api/getOddjobInfo`,//查询零工管理详情
    getInfoManageCommentList: `${config.apiUrl}/xcx/api/getInfoManageCommentList`,//查询资讯评论列表
    getInfoManageComments: `${config.apiUrl}/xcx/api/getInfoManageComments`,//获取资讯评论详细信息
    addInfoManage: `${config.apiUrl}/xcx/api/addInfoManageComments`,//新增资讯评论
    addInfoManageVisitor: `${config.apiUrl}/xcx/api/addInfoManageVisitor`,//阅读
    updateInfoManageComments: `${config.apiUrl}/xcx/api/updateInfoManageComments`,//点赞
    addCarouselImageVisitor: `${config.apiUrl}/xcx/api/addCarouselImageVisitor`,//轮播图点击
    listPartyInfoManage: `${config.apiUrl}/party/infoManage/list`,// 查询党建资讯列表
    getPartyInfoManage: `${config.apiUrl}/party/infoManage`,//查询党建资讯详情
    addPartyInfoManageVisitor: `${config.apiUrl}/party/infoManageVisitor`,//建资讯阅读
    getCompanyGridTree: `${config.apiUrl}/xcx/api/getCompanyGridTreeByCompanyId`,//区域
    getEventTypeTree: `${config.apiUrl}/affairs/eventType/getEventTypeTree`,//查询乡村事件类型树
    getPersonByAreaId: `${config.apiUrl}/village/communityPersonnel/getPersonByAreaId`,//查询人口列表
    eventReport: `${config.apiUrl}/affairs/eventReport`,//事件
    scenicManageVisitor: `${config.apiUrl}/tourism/scenicManageVisitor`,//景区浏览
    addScenicManageVisitor: `${config.apiUrl}/xcx/api/addScenicManageVisitor`,//游客景区浏览
    scenicSpotVisitor: `${config.apiUrl}/tourism/scenicSpotVisitor`,//景点浏览
    addScenicSpotVisitor: `${config.apiUrl}/xcx/api/addScenicSpotVisitor`,//游客景点浏览
    getHotlineByOrgId: `${config.apiUrl}/xcx/api/getHotlineByOrgId`,//投诉建议
    getCourtyardCombox: `${config.apiUrl}/village/courtyard/getCourtyardCombox`,//村民居住的房屋列表
    getLeaseHousePage: `${config.apiUrl}/xcx/api/getLeaseHousePage`,//租赁列表
    getLeaseHouseById: `${config.apiUrl}/xcx/api/getLeaseHouseById`,//租赁详情
    leaseHouse: `${config.apiUrl}/livelihood/leaseHouse`,//租赁
    getTradeMarketPage: `${config.apiUrl}/xcx/api/getTradeMarketPage`,//交易列表
    getTradeMarketById: `${config.apiUrl}/xcx/api/getTradeMarketById`,//交易详情
    tradeMarket: `${config.apiUrl}/livelihood/tradeMarket`,//交易
    getOddjobList: `${config.apiUrl}/xcx/api/getOddjobList`,//零工列表
    getOddjobInfo: `${config.apiUrl}/xcx/api/getOddjobInfo`,//零工详情
    oddjobManage: `${config.apiUrl}/livelihood/oddjobManage`,//零工
    getHonorImageByOrgId: `${config.apiUrl}/xcx/api/getHonorImageByOrgId`,//查询好人好事轮播图
    getDeedsPersonPage: `${config.apiUrl}/xcx/api/getDeedsPersonPage`,//好人好事人员列表
    getGoodPeopleDeedsPage: `${config.apiUrl}/xcx/api/getGoodPeopleDeedsPage`,//查询人员详情
    getGoodPeopleDeedsById: `${config.apiUrl}/xcx/api/getGoodPeopleDeedsById`,//获取事迹详情
    getVenueReservePage: `${config.apiUrl}/xcx/api/getVenueReservePage`,//查询场馆预约列表
    getVenueReserveById: `${config.apiUrl}/xcx/api/getVenueReserveById`,//获取场馆预约详细信息
    addVenueReserveOrder: `${config.apiUrl}/xcx/api/addVenueReserveOrder`,//新增场馆预约记录
    updateVenueReserveOrder: `${config.apiUrl}/xcx/api/updateVenueReserveOrder`,//修改场馆预约记录（取消）
    queryVenueReserveByDate: `${config.apiUrl}/xcx/api/queryVenueReserveByDate`,//获取场馆预约时间
    getVenueReserveOrderPage: `${config.apiUrl}/xcx/api/getVenueReserveOrderPage`,//场馆预约记录
    getVenueReserveOrderById: `${config.apiUrl}/xcx/api/getVenueReserveOrderById`,//场馆预约详情
    getActivityRegisterPage: `${config.apiUrl}/xcx/api/getActivityRegisterPage`,//查询活动预约列表
    getActivityRegisterById: `${config.apiUrl}/xcx/api/getActivityRegisterById`,//获取活动预约详细信息
    addActivityRegisterOrder: `${config.apiUrl}/xcx/api/addActivityRegisterOrder`,//新增活动预约记录
    updateActivityRegisterOrder: `${config.apiUrl}/xcx/api/updateActivityRegisterOrder`,//修改活动预约记录（取消）
    getActivityRegisterOrderPage: `${config.apiUrl}/xcx/api/getActivityRegisterOrderPage`,//活动预约记录
    getActivityRegisterOrderById: `${config.apiUrl}/xcx/api/getActivityRegisterOrderById`,//活动预约详情
    getTinyServicePage: `${config.apiUrl}/xcx/api/getTinyServicePage`,//微服务列表
    getTinyServiceById: `${config.apiUrl}/xcx/api/getTinyServiceById`,//微服务详情
    addTinyServiceHandle: `${config.apiUrl}/xcx/api/addTinyServiceHandle`,//微服务提交资料
    updateTinyServiceHandle: `${config.apiUrl}/xcx/api/updateTinyServiceHandle`,//微服务修改提交资料
    getTinyServiceHandlePage: `${config.apiUrl}/xcx/api/getTinyServiceHandlePage`,//微服务我提交的列表
    addVolunteer: `${config.apiUrl}/xcx/api/addVolunteer`,//加入志愿者
    getCommunityVolunteer: `${config.apiUrl}/xcx/api/getCommunityVolunteer`,//获取志愿详情
    communityVolunteer: `${config.apiUrl}/xcx/api/communityVolunteer`,//志愿者
    getVolunteerOrganization: `${config.apiUrl}/xcx/api/getVolunteerOrganization`,//志愿组织列表
    getVolunteerOrganizationById: `${config.apiUrl}/xcx/api/getVolunteerOrganizationById`,//获取志愿组织详细信息
    getVolunteerOrganizationPersonByPersonId: `${config.apiUrl}/xcx/api/getVolunteerOrganizationPersonByPersonId`,//获取已加入组织审核信息
    addVolunteerOrganizationPerson: `${config.apiUrl}/xcx/api/addVolunteerOrganizationPerson`,//新增志愿组织人员申请
    getVolunteerOrganizationByPersonId: `${config.apiUrl}/xcx/api/getVolunteerOrganizationByPersonId`,//查询我已加入的志愿组织列表
    getVolunteerActivityPage: `${config.apiUrl}/xcx/api/getVolunteerActivityPage`,//查询志愿者活动风采列表
    getVolunteerActivityById: `${config.apiUrl}/xcx/api/getVolunteerActivityById`,//获取志愿者活动风采详细信息
    getHealthHotlinePage: `${config.apiUrl}/xcx/api/getHealthHotlinePage`,//热线查询
    getPointsProductPage: `${config.apiUrl}/xcx/api/getPointsProductPage`,//查询积分商品列表
    getPointsProductById: `${config.apiUrl}/xcx/api/getPointsProductById`,//获取积分商品详细信息
    addPointsProductOrder: `${config.apiUrl}/xcx/api/addPointsProductOrder`,//新增积分商品兑换记录
    getPointsProductOrderPage: `${config.apiUrl}/xcx/api/getPointsProductOrderPage`,//查询积分商品兑换记录列表
    getPointsProductOrderById: `${config.apiUrl}/xcx/api/getPointsProductOrderById`,//获取积分商品兑换记录详细信息
    cancelProduct: `${config.apiUrl}/xcx/api/cancelProduct`,//积分商品订单取消兑换
    getSurplusScount: `${config.apiUrl}/xcx/api/getSurplusScount`,//查询当前积分
    getPointsDetailsPage: `${config.apiUrl}/xcx/api/getPointsDetailsPage`,//查询积分明细列表
    getApiProjectList: `${config.apiUrl}/xcx/api/getApiProjectList`,//家庭项目查询
    getApiProjectItemList: `${config.apiUrl}/xcx/api/getApiProjectItemList`,//个人项目查询
    projectItem: `${config.apiUrl}/payment/projectItem`,//缴费账单列表
    getPaymentDetailPage: `${config.apiUrl}/xcx/api/getPaymentDetailPage`,//缴费订单
    getPaymentDetailById: `${config.apiUrl}/xcx/api/getPaymentDetailById`,//缴费订单详情
    getEnterpriseMerchant: `${config.apiUrl}/xcx/api/getEnterpriseMerchant`,//企业类型
    getEnterpriseByPageList: `${config.apiUrl}/xcx/api/getEnterpriseByPageList`,//企业列表
    getEnterpriseById: `${config.apiUrl}/xcx/api/getEnterpriseById`,//企业详情
    getEnterpriseProductById: `${config.apiUrl}/xcx/api/getEnterpriseProductById`,//商品详情
    getCarParkPage: `${config.apiUrl}/xcx/api/getCarParkPage`,//停车场列表
    getCarParkById: `${config.apiUrl}/xcx/api/getCarParkById`,//停车场详情
    getWashroomPage: `${config.apiUrl}/xcx/api/getWashroomPage`,//洗手间详情
    getWashroomById: `${config.apiUrl}/xcx/api/getWashroomById`,//洗手间详情
    getCompanyByOrgId: `${config.apiUrl}/xcx/api/getCompanyByOrgId`,//当前机构信息
    getComplainRecordPage: `${config.apiUrl}/xcx/api/getComplainRecordPage`,//投诉记录
    getComplainRecordById: `${config.apiUrl}/xcx/api/getComplainRecordById`,//投诉记录详细
    addComplainRecord: `${config.apiUrl}/xcx/api/addComplainRecord`,//新增投诉记录
    getFinanceManagePage: `${config.apiUrl}/xcx/api/getFinanceManagePage`,//查询资金管理列表
    getResourceManagePage: `${config.apiUrl}/xcx/api/getResourceManagePage`,//查询资源管理列表
    getAssetManagePage: `${config.apiUrl}/xcx/api/getAssetManagePage`,//查询资产管理列表
    getScountRankPage: `${config.apiUrl}/xcx/api/getScountRankPage`,//查询积分排名
    getAssetTypeTree: `${config.apiUrl}/xcx/api/getAssetTypeTree`,//查询资产树
    getResourceTypeTree: `${config.apiUrl}/xcx/api/getResourceTypeTree`,//查询资源树
  },
  visitor: {
    listPartyInfoManage: `${config.apiUrl}/party/api/getInfoManageList`,// 查询党建资讯列表
    getPartyInfoManage: `${config.apiUrl}/party/api/getInfoManage`,//查询党建资讯详情
    addPartyInfoManageVisitor: `${config.apiUrl}/party/api/addPartyInfoManageVisitor`,//建资讯阅读
  },
  dict: {
    list: `${config.apiUrl}/xcx/api/types`,//查询列表
  },
}
export default interfaces;
